import React from "react";
import PropTypes from "prop-types";
import HelperText from "./HelperText";

function HelperTextLabel({ label, fieldDescriptionKey }) {
  return (
    <div className="varsome-horiz-list-label">
      {label}
      <HelperText fieldDescriptionKey={fieldDescriptionKey} />
    </div>
  );
}

HelperTextLabel.propTypes = {
  label: PropTypes.string.isRequired,
  fieldDescriptionKey: PropTypes.string.isRequired,
};

export default HelperTextLabel;
